



import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class GridDateColumn extends Vue {
    /**
     * Row parameters provided by ag-grid-vue
     */
    params!: { value?: string; format?: string };

    get dateString(): string {
        if (!this.params.format) {
            this.params.format = "l";
        }
        return this.params.value
            ? moment(this.params.value).format(this.params.format)
            : "";
    }
}
